import { render } from "./Loading.vue?vue&type=template&id=858818bc"
import script from "./Loading.vue?vue&type=script&lang=ts"
export * from "./Loading.vue?vue&type=script&lang=ts"

import "./Loading.vue?vue&type=style&index=0&id=858818bc&lang=scss"
script.render = render

export default script